export default {
  companyUserGetList: {
    method: 'post',
    url: '/client/company/user/list'
  },
  getCompanyBranch: {
    method: 'post',
    url: '/client/company/branch/get-company-branchs'
  },
  getList: {
    method: 'post',
    url: '/client/company/list'
  },
  getHoldingCompany: {
    method: 'get',
    url: '/client/company/holding-company'
  },
  updateCompanyInfo: {
    method: 'post',
    url: '/client/company/edit-information'
  },
  getCompanyUser: {
    method: 'post',
    url: '/client/company/user'
  },
  selectCompanyUser: {
    method: 'get',
    url: '/client/company/user/find?key=KEY&groupType=GROUPTYPE'
  },
  historyList: {
    method: 'post',
    url: '/client/company/history/list'
  },
  updateInvoice: {
    method: 'post',
    url: '/client/company/update-invoice'
  },
  updateBanking: {
    method: 'post',
    url: '/client/company/update-banking'
  },
  find: {
    method: 'get',
    url: '/client/company/find?key=KEY&type=TYPE'
  },
  companyUserArchive: {
    method: 'delete',
    url: '/client/company/user/archive'
  },
  companyGroupArchive: {
    method: 'delete',
    url: '/client/company/group/archive'
  },
  users: {
    resendActivation: {
      method: 'post',
      url: '/client/company/user/ID/resend-activation'
    }
  },
  api_key: {
    create: {
      method: 'post',
      url: '/client/company/api-key'
    },
    get: {
      method: 'post',
      url: '/client/company/api-key/list'
    },
    edit: {
      method: 'put',
      url: '/client/company/api-key/ID'
    },
    archive: {
      method: 'delete',
      url: '/client/company/api-key/archive'
    },
    delete: {
      method: 'delete',
      url: '/client/company/api-key'
    }
  },
  connect: {
    create: {
      method: 'post',
      url: '/client/company/connect'
    },
    gets: {
      method: 'post',
      url: '/client/company/connect/list'
    },
    delete: {
      method: 'delete',
      url: '/client/company/connect'
    }
  }
}
